import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import FilterHeader from '../../webcommon/header/filterheader/FilterHeader';

import * as selectors from './selectors';
import { staticDataIsdaLoaded } from './actions';
import defaultStyles from './StaticDataIsda.module.scss';
import CustomGrid from '../customgrid/CustomGrid';

const wrapCell = (value, column) => {
    let wrappedValue = value;
    if (column.bold) {
        wrappedValue = <b>{ wrappedValue }</b>;
    }
    if (column.alignment === 'right') {
        wrappedValue = <div style={ { textAlign: 'right' } }>{ wrappedValue }</div>;
    } else if (column.alignment === 'center') {
        wrappedValue = <div style={ { textAlign: 'center' } }>{ wrappedValue }</div>;
    }
    return wrappedValue;
};

export const StaticDataIsdaUnconnected = (props) => {
    const { staticDataIsdaLoaded, location } = props;
    useEffect(() => {
        staticDataIsdaLoaded(location.search);
    }, [staticDataIsdaLoaded, location]);

    return (
        <div className={ props.styles.staticDataIsdaWrapper }>
            <div className={ props.styles.staticDataFilter }>
                <FilterHeader
                    fixed
                    title="StaticData"
                    id="StaticDataIsda"
                />
            </div>
            { props.productClassData && props.productClassData.map(c => (
                <CustomGrid
                    key={ c.name }
                    csvFilename={ `${c.name}.csv` }
                    columns={ c.columns.map(col => ({
                        ...col,
                        renderCell: ({ value }) => wrapCell(value, col)
                    })) }
                    rows={ c.rows }
                    styles={ props.styles }
                    title={ c.name }
                />
            )) }
        </div>
    );
};

StaticDataIsdaUnconnected.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string
    }).isRequired,
    staticDataIsdaLoaded: PropTypes.func.isRequired,
    productClassData: PropTypes.arrayOf(PropTypes.shape({})),
    styles: PropTypes.objectOf(PropTypes.string)
};

StaticDataIsdaUnconnected.defaultProps = {
    styles: defaultStyles,
    productClassData: null
};

const mapStateToProps = state => ({
    displayedProductClasses: selectors.getDisplayedProductClasses(state),
    productClassData: selectors.getProductClassData(state)
});

const mapDispatchToProps = {
    staticDataIsdaLoaded
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(StaticDataIsdaUnconnected)
);
